import { render, staticRenderFns } from "./SettingExam.vue?vue&type=template&id=daf39db2"
import script from "./SettingExam.vue?vue&type=script&lang=js"
export * from "./SettingExam.vue?vue&type=script&lang=js"
import style0 from "./SettingExam.vue?vue&type=style&index=0&id=daf39db2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports